import React from 'react';
import { Alert } from 'reactstrap';
import axios from 'axios';

interface IErrorBoundaryProps {
  readonly children: React.ReactNode;
}

interface IErrorBoundaryState {
  readonly error: any;
  readonly errorInfo: any;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  readonly state: IErrorBoundaryState = { error: undefined, errorInfo: undefined };

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  logErrorOnBackend = (error: any, errorInfo: any) => {
    const errorId = Date.now();

    axios.post(`/api/frontend-errors/${errorId}`, {error, errorInfo});

    return errorId;
  }

  render() {
    const { error, errorInfo } = this.state;
    if (errorInfo) {
      return (
        <div>
          <Alert color="warning">Došlo je do pogreške! Molimo javite se administratoru. (ref.br. {this.logErrorOnBackend(error.toString(), errorInfo.componentStack.toString())})</Alert>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
